import { useNavigate } from "react-router-dom";
import brixigoLogo from "../assets/images/logo_brixigo3.png";
import "./bookDemo.css";

export default function DemoChrome({ children, backLabel, onBack }) {
  const navigate = useNavigate();
  const handleBack = onBack || (() => navigate("/"));

  return (
    <div className="bd-page">
      <header className="bd-nav">
        <div className="bd-nav-inner">
          <img
            src={brixigoLogo}
            alt="Brixigo Technologies"
            style={{ height: 48, width: "auto", maxWidth: 200, objectFit: "contain" }}
          />
          {backLabel ? (
            <button type="button" className="bd-back" onClick={handleBack}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              {backLabel}
            </button>
          ) : null}
        </div>
      </header>
      <main className="bd-main">{children}</main>
    </div>
  );
}
